export default function createSearchParams(params) {
  if (params === null || params === undefined) return ''

  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(`${key}[]`, v))
    } else {
      searchParams.append(key, value)
    }
  }
  return searchParams.toString()
}